<a [href]="src" target="_blank">
    <img [src]="src" alt="{{image.title}}" />
    <div>🔗 {{image.title}}</div>
</a>